import { api } from './client';
import type { StoredImageResponse } from '../features/images/types';
export type { StoredImageResponse } from '../features/images/types';

const API_BASE = process.env.REACT_APP_API_URL ?? '';

function getBase(): string {
  return (API_BASE || '').replace(/\/$/, '');
}

/** URL for displaying an image by its stored image id (GUID). Use this for img src. */
export function getImageUrlById(id: string | null | undefined): string {
  if (!id) return '';
  const base = getBase();
  const path = `/api/images/file/${id}`;
  return base ? `${base}${path}` : path;
}

/** @deprecated Prefer getImageUrlById(imageId) – backend serves by id at GET /api/images/:id */
export function getImageUrl(fileName: string): string {
  if (!fileName) return '';
  const base = getBase();
  return base ? `${base}/uploads/images/${fileName}` : `/uploads/images/${fileName}`;
}

export async function uploadImage(file: File): Promise<StoredImageResponse> {
  const formData = new FormData();
  formData.append('file', file);
  return api.postForm<StoredImageResponse>('/api/images/upload', formData);
}
